













import { Component, Vue } from 'vue-property-decorator';
import { Project, projects } from '@/data/projects.ts';
import ProjectCard from '@/components/ProjectCard.vue';

@Component({ components: { ProjectCard } })
export default class Home extends Vue {
  public projects: Project[] = projects;
}
